import {
	LOGIN_GATE_PUBLIC_PATHS,
	isLoginGateExempt
} from "@nwt/norce-pwa/loginGate";

/**
 * A page guests may open on a login-gated site, shown without the shop chrome
 * (menu, search, prices): always login/reset-password, the extra public paths
 * only for guests.
 */
export const useLoginGateScreen = () => {
	const route = useRoute();
	const localePath = useLocalePath();
	const { requireLogin, requireLoginPublicPaths } =
		useRuntimeConfig().public.norce;
	const user = userStore();

	const isOn = (paths: readonly string[]) =>
		isLoginGateExempt(
			route.path,
			paths.map((path) => localePath(path))
		);

	return computed(
		() =>
			Boolean(requireLogin) &&
			(isOn(LOGIN_GATE_PUBLIC_PATHS) ||
				(!user.getUser && isOn(requireLoginPublicPaths ?? [])))
	);
};
